// extracted by mini-css-extract-plugin
export default {"container":"Portfoplus_container__qyzRO","TaglineFit":"Portfoplus_TaglineFit__P3R1N","Fit":"Portfoplus_Fit__bTY07","image":"Portfoplus_image__N9Tho"};